import {getUserLocation} from '../api/location';
import {loadScript} from '../utils';

import './responsive.css';
import './theme.css';

export const GDPR_SCRIPT = 'https://cmp.dmgmediaprivacy.co.uk/2.8.23-newzit.1/iife/mol-ads-cmp.min.js';
export const CCPA_SCRIPT = 'https://cmp.dmgmediaprivacy.co.uk/2.8.18-newzit-ccpa-4/iife/mol-ads-cmp.min.js';

interface WindowWithCriteria extends Window {
  PageCriteria?: {
    geo?: string;
    region?: string;
  };
}

interface LoadIfNeededArgs {
  render?: boolean;
}

export const loadIfNeeded = async ({render = true}: LoadIfNeededArgs = {}) => {
  try {
    const data = await getUserLocation();

    if (!data) {
      throw new Error('No location could be established');
    }

    const isCCPA = data.Country === 'US';

    (window as WindowWithCriteria).PageCriteria = {
      geo: data.Country,
      region: data.REGION_CODE
    };

    if (!data.INEU && !isCCPA) {
      return false;
    }

    const params: {[key: string]: string} = {
      id: 'mol-ads-cmp'
    };

    if (render) {
      params['data-render'] = 'true';
    }

    await loadScript(isCCPA ? CCPA_SCRIPT : GDPR_SCRIPT, params);

    return true;
  } catch (error) {
    // Do not load
    return false;
  }
};
